var _circle, _g, _path, _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyAbout = function SvgEmptyAbout(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 103,
    viewBox: "0 0 148 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.3856,
    cy: 51.2188,
    r: 51.2188,
    fill: "#262626",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4525_60210)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.7627,
    y: 21.9995,
    width: 132.476,
    height: 58.5357,
    rx: 6.16165,
    fill: "#FBFDFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5969 65.25C50.5969 63.0404 50.5969 61.9355 50.3242 61.0365C49.7102 59.0124 48.1262 57.4284 46.102 56.8144C45.203 56.5417 44.0982 56.5417 41.8885 56.5417H33.9719C31.7622 56.5417 30.6574 56.5417 29.7584 56.8144C27.7343 57.4284 26.1503 59.0124 25.5363 61.0365C25.2635 61.9355 25.2635 63.0404 25.2635 65.25M45.0552 43.875C45.0552 47.81 41.8652 51 37.9302 51C33.9952 51 30.8052 47.81 30.8052 43.875C30.8052 39.94 33.9952 36.75 37.9302 36.75C41.8652 36.75 45.0552 39.94 45.0552 43.875Z",
    stroke: "#262626",
    strokeOpacity: 0.6,
    strokeWidth: 1.54041,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.615,
    y: 36.9712,
    width: 45.4422,
    height: 6.16165,
    rx: 3.08083,
    fill: "#262626",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.615,
    y: 47.7539,
    width: 45.4422,
    height: 6.16165,
    rx: 3.08083,
    fill: "#262626",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.615,
    y: 58.5371,
    width: 45.4422,
    height: 6.16165,
    rx: 3.08083,
    fill: "#262626",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4525_60210",
    x: 0.0606279,
    y: 14.2974,
    width: 147.88,
    height: 73.9398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.85103
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4525_60210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4525_60210",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyAbout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "emptyAbout.52a77929a4376dc570a84fa49dfe2228.svg";